// LoginDetailsSection.js
import React from 'react';

const LoginDetailsSection = ({ userDetails, activeSection }) => (
  <div
    id="login-details-card"
    className={`bg-white rounded-lg shadow-lg p-6 transition-all ease-in-out duration-300 ${
      activeSection === 'loginDetails' ? 'border' : ''
    }`}
  >
    <h1 className="text-xl font-bold text-gray-900">Login Details</h1>
    <p className="text-gray-600 mt-2">Manage your mobile number, email address, and password.</p>

    <div className="mt-6 space-y-4">
      <div className="flex justify-between">
        <span className="text-gray-700 text-md font-medium">Mobile Number</span>
        <span className="text-gray-900 font-semibold">{userDetails.phone_number || 'Not provided'}</span>
      </div>

      <div className="flex justify-between">
        <span className="text-gray-700 text-md font-medium">Email</span>
        <span className="text-gray-900 font-semibold">{userDetails.email}</span>
      </div>
    </div>
  </div>
);

export default LoginDetailsSection;
